/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorFromJSON, FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorToJSON, } from './FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseError';
import { FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataFromJSON, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataToJSON, } from './FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseData';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponse(value) {
    return true;
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseFromJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Error': json['Error'] == null ? undefined : FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorFromJSON(json['Error']),
        'Data': json['Data'] == null ? undefined : FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataFromJSON(json['Data']),
        'DebugAccountId': json['DebugAccountId'] == null ? undefined : json['DebugAccountId'],
        'DebugMyGamesId': json['DebugMyGamesId'] == null ? undefined : json['DebugMyGamesId'],
    };
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseToJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Error': FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorToJSON(value['Error']),
        'Data': FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataToJSON(value['Data']),
        'DebugAccountId': value['DebugAccountId'],
        'DebugMyGamesId': value['DebugMyGamesId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponse.js.map